import { render, staticRenderFns } from "./idnex.vue?vue&type=template&id=49ab5f04&scoped=true&"
import script from "./idnex.vue?vue&type=script&lang=js&"
export * from "./idnex.vue?vue&type=script&lang=js&"
import style0 from "./idnex.vue?vue&type=style&index=0&id=49ab5f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab5f04",
  null
  
)

export default component.exports